<template>
    <div class="downloadClient-view">
        <div ref="downloadClientViewWrapper"
             class="downloadClient-view-wrapper">
            <div class="content-mask">
                <h5 class="client-title pc-client">
                    {{ langTransfer('PC客户端') }}
                </h5>
                <h5 class="client-title mobile-client">
                    {{ langTransfer('移动客户端') }}
                </h5>
                <p class="client-summary pc-summary">
                    {{ langTransfer('给你快速稳定的全新体验') }}
                </p>
                <p class="client-summary mobile-summary">
                    <span>{{ langTransfer('一键借阅') }}</span>
                    <!--<span>{{ langTransfer('资源离线') }}</span>-->
                    <span>{{ langTransfer('随身阅读') }}</span>
                    <span>{{ langTransfer('极致的EPUB阅读体验') }}</span>
                </p>
                <a href="http://u.qikan.cn/weblibrary/install.exe"
                   download="精品阅览室安装程序.exe">
                    <button class="pcClient-download-btn">
                        {{ langTransfer('立即下载') }}
                    </button>
                </a>
                <img src="@/assets/download/pc.png" class="exhibition-img pc-exhibition">
                <img src="@/assets/download/mobile.png" class="exhibition-img mobile-exhibition">
                <img src="@/assets/download/iphone.png" class="mobile-icon iphone-icon">
                <img src="@/assets/download/android.png" class="mobile-icon android-icon">
                <p class="mobile-info iphone-info">iPhone</p>
                <p class="mobile-info android-info">Android</p>
                <div class="mobile-qrcode-mask">
                    <div class="corner-arrow"/>
                    <div class="corner-arrow"/>
                    <div class="corner-arrow"/>
                    <div class="corner-arrow"/>
                    <div ref="qrcode" class="qrcode-mask">
                         <img src="@/assets/download/wechat.jpg" style="width:180px;height:180px;">
                    </div>
                </div>
                <div class="site-footer">
                    <Footer/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import QRCode from 'qrcodejs2'
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        data () {
            return {
            }
        },
        computed: {
            siteName () {
                return this.$store.state.serviceName
            },
            appDownloadUrl () {
                return this.$store.state.appDownloadUrl
            }
        },
        watch: {
            appDownloadUrl (newVal) {
                if (newVal) {
                    //this.initQrCode(newVal)
                }
            }
        },
        activated () {
        },
        mounted () {
            this.initBScroll()
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.downloadClientBScroll = new BScroll(this.$refs.downloadClientViewWrapper, {
                        bounce: false,
                        click: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                })
            },
            initQrCode (text) {
                const ele = this.$refs.qrcode
                ele.innerHTML = ''
                this.qrcode = new QRCode(ele, {
                    width: 180,
                    height: 180,
                    text
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .downloadClient-view {
        width: 100%;
        height: 100%;
        background: #fff;
    }

    .downloadClient-view-wrapper {
        width: 1140px;
        height: 100%;
        overflow: hidden;
        margin: 0 auto;
    }

    .content-mask {
        width: 100%;
        height: 1566px;
        position: relative;
    }

    .site-footer {
        border-top: none;
        position: absolute;
        bottom: 0;
    }

    .client-title  {
        position: absolute;
        
        font-size: 56px;
        color: #1A1A1A;
        line-height: 56px;
    }

    .pc-client {
        top: 140px;
        left: 22px;
    }

    .mobile-client {
        top: 812px;
        left: 665px;
    }

    .client-summary {
        position: absolute;
        
        font-size: 32px;
        color: #999999;
        letter-spacing: 0;
        line-height: 52px;
        width: 490px;

        span {
            margin-right: 30px;
        }
    }

    .pc-summary {
        top: 246px;
        left: 22px;
    }

    .mobile-summary {
        top: 918px;
        left: 665px;
    }

    .pcClient-download-btn {
        position: absolute;
        left: 22px;
        top: 430px;
        width: 180px;
        height: 54px;
        box-sizing: border-box;
        padding-left: 44px;
        background-color: #FF5840;
        border-radius: 8px;
        
        font-size: 20px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 20px;
        background-image: url("../../assets/download/download.png");
        background-repeat: no-repeat;
        background-size: 30px 30px;
        background-position: 27px 12px;
    }

    .exhibition-img {
        position: absolute;
    }

    .pc-exhibition {
        top: 110px;
        left: 544px;
        height: 477px;
    }

    .mobile-exhibition {
        top: 766px;
        left: 22px;
        width: 508px;
    }

    .mobile-icon {
        position: absolute;
        width: 42px;
    }

    .iphone-icon {
        left: 926px;
        top: 1168px;
    }

    .android-icon {
        left: 1024px;
        top: 1169px;
    }

    .mobile-info {
        position: absolute;
        
        font-size: 24px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
        line-height: 28px;
    }

    .iphone-info {
        left: 908px;
        top: 1228px;
        width: 42px;
    }

    .android-info {
        left: 1004px;
        top: 1228px;
        width: 42px;
    }

    .mobile-qrcode-mask {
        width: 200px;
        height: 200px;
        position: absolute;
        left: 665px;
        top: 1117px;

        .corner-arrow {
            width: 27px;
            height: 27px;
            box-sizing: border-box;
            border: 3px solid #0084FF;
            position: absolute;
        }

        .corner-arrow:nth-child(1) {
            border-right: 0;
            border-bottom: 0;
            top: 0;
            left: 0;
        }

        .corner-arrow:nth-child(2) {
            border-left: 0;
            border-bottom: 0;
            top: 0;
            right: 0;
        }

        .corner-arrow:nth-child(3) {
            border-right: 0;
            border-top: 0;
            bottom: 0;
            left: 0;
        }

        .corner-arrow:nth-child(4) {
            border-left: 0;
            border-top: 0;
            bottom: 0;
            right: 0;
        }

        .qrcode-mask {
            width: 180px;
            height: 180px;
            background: #E9E9E9;
            position: absolute;
            left: 10px;
            top: 10px;
        }
    }
</style>
